var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7514 15.5822C22.3636 16.9697 19.7525 16.9158 15.749 16.9158C13.1732 16.9158 11.0849 14.8243 11.0835 12.2485C11.0835 8.24769 11.0296 5.63511 12.4173 4.24763C13.805 2.86016 14.4179 2.91633 20.5652 2.91633C21.1593 2.91379 21.4583 3.63222 21.0383 4.05228L17.8731 7.21768C17.0698 8.02114 17.0676 9.32373 17.871 10.1271C18.6745 10.9305 19.9772 10.9305 20.7808 10.1273L23.9468 6.96266C24.3669 6.5427 25.0855 6.84165 25.0829 7.43562C25.0829 13.5819 25.1391 14.1948 23.7514 15.5822Z",
    stroke: "#7157C2",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7501 16.9167L8.5499 24.1169C7.26125 25.4055 5.17191 25.4055 3.88325 24.1169C2.59458 22.8282 2.59458 20.7388 3.88325 19.4502L11.0834 12.25",
    stroke: "#7157C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4272 21.584H6.41675",
    stroke: "#7157C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.7312dd1364f4dca5ea1f7a1f7eedd842.svg";
export { ForwardRef as ReactComponent };